<template>
    <div  class="common-margin">
        <el-card>
            <h1 class=" mar_bot">各机构走势图 TOP10</h1>
            <div class="flex-row vertical-center flow-justify mar_bot">
                <el-radio-group v-model="timeRange">
                    <el-radio label="1">昨日</el-radio>
                    <el-radio label="2">最近7天</el-radio>
                    <el-radio label="3">最近30天</el-radio>
                </el-radio-group>
                <el-radio-group v-model="topType" size="small">
                    <el-radio-button label="1">交易额</el-radio-button>
                    <el-radio-button label="2">交易笔数</el-radio-button>
                    <el-radio-button label="3">会员量</el-radio-button>
                </el-radio-group>
            </div>

            <top-tran-chart ref="topjye" :params="charData" v-if="topType == 1"></top-tran-chart>
            <top-num-chart ref="topjybs" :params="charData" v-else-if="topType == 2"></top-num-chart>
            <top-mem-chart ref="tophyl" :params="charData" v-else-if="topType == 3"></top-mem-chart>

            <!--<top-tran-chart ref="topjye" :params="topTranData" v-show="topType == 1"></top-tran-chart>-->
            <!--<top-num-chart ref="topjybs" :params="topNumData" v-show="topType == 2"></top-num-chart>-->
            <!--<top-mem-chart ref="tophyl" :params="topMemData" v-show="topType == 3"></top-mem-chart>-->

        </el-card>
    </div>

</template>

<script>

    import TopTranChart from '../fragment/echarts/TopTranChart'
    import TopMemChart from '../fragment/echarts/TopMemChart'
    import TopNumChart from '../fragment/echarts/TopNumChart'

    import StatisticsService from 'service/StatisticsService'
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "GraphStatistics",
        components: {
            TopTranChart,
            TopNumChart,
            TopMemChart,
        },
        data() {
            return {
                topTranData: {},
                topNumData: {},
                topMemData: {},
                topType:'1',
                timeRange:'1',
                charData:{},
            }
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            submitData() {
                const params = {
                    userId : this.userId,
                    timeRange: this.timeRange
                };
                return params;
            },
            ...mapGetters(['serverType','tatId','userId'])
        },
        mounted() {
            this.getList(this.topType);
            window.addEventListener('resize', this.chartResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.chartResize);
        },
        watch:{
            timeRange(val,oldVal){
                this.getList(this.topType);
            },
            topType(val,oldVal){
                this.getList(val);
            },
        },
        methods: {
            //调整窗口
            chartResize() {
                try {
                    this.$refs.topjye.charts.resize();
                    this.$refs.topjybs.charts.resize();
                    this.$refs.tophyl.charts.resize();
                } catch (reason) {
                    console.log(reason)
                }
            },
            getList(type) {
                let fun = null;
                fun = type ==1 ? StatisticsService.gmvtop : type == 2 ? StatisticsService.tranCountTOP : StatisticsService.memCountTOP;
                this.doLoad(fun, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        // this.topTranData = result;
                        // this.topNumData = result;
                        // this.topMemData = result;
                        this.charData = result;
                    });
                }, '信息获取失败')
            },
        },

    }
</script>

<style scoped>
    .mar_bot{
        margin-bottom: 30px;
    }

    h1{
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/Welcome_chart.vue